import { Component, OnInit } from '@angular/core';
import {Subscription} from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow-summary.component.html',
  styleUrls: ['./workflow-summary.component.scss']
})
export class WorkflowSummaryComponent implements OnInit {

  fetchSubscription: Subscription;
  overviewData: any;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    const url = window.location.origin +  '/api/dm/workflow-overview';
    this.fetchSubscription = this.http.get(url).subscribe((data: any[]) => {
      this.overviewData = data;
    });
  }

}
